import { closePopup, openPopup } from '@/popups';
import { select2Init } from '@/components/select2';
import { datepickerInit } from '@/components/datepicker';

export function accountEdit() {
  const $accountEdit = $('.account-edit');
  if (!$accountEdit || $accountEdit.length === 0) return;

  /*
   * Переключение формы для лектора
   * */

  const $lectorToggle = $('.account-edit-lector-toggle');
  const $lectorToggleRules = $('.account-edit-lector-toggle-rules');
  const $lectorRules = $('.account-edit-lector-rules');
  const $lector = $('.account-edit-lector');
  const $popup = $('#account-lector-accept');

  if ($lectorToggle.prop('checked')) {
    $lector.addClass('show');
  }

  $lectorToggle.on('change', (e) => {
    const checked = $(e.currentTarget).prop('checked');

    if (checked) {
      openPopup($popup);
    } else {
      $lectorToggleRules.prop('checked', false).trigger('change');
      $lector.removeClass('show');
      $lectorRules.removeClass('show');
    }
  });

  $lectorToggleRules.on('change', (e) => {
    const checked = $(e.currentTarget).prop('checked');
    if (checked) {
      $lector.addClass('show');
    } else {
      $lector.removeClass('show');
    }
  });

  $('.account-lector-accept').on('click', () => {
    $lectorRules.addClass('show');
    closePopup($popup);
  });

  $('.account-lector-dismiss').on('click', () => {
    closePopup($popup);
    $lectorToggleRules.prop('checked', false).trigger('change');
    $lectorToggle.prop('checked', false).trigger('change');
  });

  /*
   * Добавление дополнительной специальности
   * */

  const $buttonAdd = $('.account-edit-button-add-specialization');
  const $specializations = $('.account-edit-additional-specializations');

  $buttonAdd.on('click', (e) => {
    e.preventDefault();

    $.ajax({
      url: '/assets/ajax/account-edit-specializations.html',
      success: (data) => {
        $specializations.append(data);

        select2Init();
        datepickerInit();
      },
    });
  });
}
